import React from 'react';
import { Layout, Seo } from '@layout';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { getRootUrl } from '@utils/urlHelpers.util';
import { HeroSection, HeadToToeWeddingSection, QuoteSection, CuratedRegistrySection, WeddingSuiteSection } from '@sections/rachel-zoe';

const RZ_PAGE = `rachelzoe`;

const RachelZoe: React.FC = () => {
  const canonicalURL = getRootUrl(`/${RZ_PAGE}`);
  return (
    <Layout
      transparentHeaderButtonVariant="defaultPrimeWeddingWebsites"
      isTransparentHeader={true}
      headerScrollThresholdVh={35}
      page={RZ_PAGE}
    >
      <Seo
        ogImage="common/meta_share/rz-social-sharing.jpg"
        title={rachelZoePageData.seo.title}
        description={rachelZoePageData.seo.content}
        canonicalURL={canonicalURL}
      />
      <HeroSection />
      <HeadToToeWeddingSection />
      <QuoteSection />
      <CuratedRegistrySection />
      <WeddingSuiteSection />
    </Layout>
  );
};

export default RachelZoe;
